mutation ConnectPaynet($input: ConnectPaynetInput!) {
  connectPaynet(input: $input) {
    id
    paymentSettings {
      publishableKey
      secretKeyMask
      connectedAt
      paynet {
        merchantCode
        secretKeyMask
        saleArea
        connectedAt
      }
    }
  }
}
